import { useParams } from 'react-router-dom';

import { Loading } from '@/components/shared/Loading/Loading';

import JourneyEditorView from './components/Editor/JourneyEditorView';
import { NEW_JOURNEY_ID } from './const';
import { journeyErrorMessage, useJourney } from './services/JourneyService';

const JourneyEditor = () => {
  const { id = NEW_JOURNEY_ID } = useParams();

  if (id === NEW_JOURNEY_ID) {
    return <JourneyEditorView />;
  }

  // Keyed by the address, so every opened journey (a fresh copy, say) gets its own fetch and editor.
  return <SavedJourneyEditor key={id} id={id} />;
};

const SavedJourneyEditor = ({ id }: { id: string }) => {
  const { data: journey, error, isFetchedAfterMount } = useJourney(id);

  if (!isFetchedAfterMount) {
    return (
      <div className="w-full p-6">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full p-6">
        <div className="text-center py-10 text-red-600 bg-red-50 border border-red-200 rounded-lg">
          {journeyErrorMessage(error, 'Failed to load the journey')}
        </div>
      </div>
    );
  }

  return <JourneyEditorView journey={journey} />;
};

export default JourneyEditor;
